module.exports = __webpack_public_path__ + "img/wechat_code_shipper.95659d12.jpg";